import { Footer } from 'modules/home/components/Footer';
import { Header } from 'modules/home/components/Header';
import { NewPartners } from 'modules/home/components/NewPartners';
import { PartnersCollection } from 'modules/home/components/NewPartners/NewPartners.types';

import contentfulData from '../../services/contentful';
import { queryLandingPage } from '../../services/contentful/querys';

type PartnersPageProps = {
  allPartners: PartnersCollection[];
};

const PartnersPage = ({ allPartners }: PartnersPageProps) => {
  return (
    <>
      <Header />
      <main>
        {allPartners.map((category) => {
          return (
            <NewPartners
              key={category.items[0].category.title}
              items={category.items}
              hasLink={false}
              extraClass="page"
            />
          );
        })}
      </main>
      <Footer />
    </>
  );
};

export default PartnersPage;

export async function getServerSideProps() {
  const data = await contentfulData(queryLandingPage());

  return {
    props: {
      allPartners: data.allPartners,
    },
  };
}
